import React, { useState } from "react";
import "../../components/formStyleSheet/FormStyling.css";
import { toast } from "react-toastify";
import Button from "../button/Button";
import ModalComponent from "../modalSetup/Modal";
import { Modal } from "react-bootstrap";
import {
  useLoginVendorMutation,
} from "../../services/Api";
import { useDispatch } from "react-redux";
import { loggedIn } from "../../redux/AuthSlice";
import PhoneInput from "react-phone-input-2";

const VendorloginModal = (props) => {

  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState('');
  const dispatch = useDispatch();

  const [loginVendor, { isLoading: loginVendorLoading }] = useLoginVendorMutation();

  const onLogin = () => {
    if (!phone) {
      alert("Phone Number is required for login!");
      return;
    }

    let data = {
      phone_no: `+${phone}`,
      password: password,
    };

    // if (phone?.length == 12) {
    loginVendor({ data: data })
      .unwrap()
      .then((payload) => {
        if (payload.status) {
          const userData = {
            token: payload?.access_token,
            user: payload?.vendor,
            role: "vendor",
          };
          dispatch(loggedIn(userData));
          toast.success("Logged In successfully");
          props.handleCloseVendorloginModal();
        } else {
          toast.error(payload?.message);
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
    // } else {
    //   toast.error("Invalid phone number");
    // }
  };

  const handlePhoneChange = (value) => {
    if (!value.startsWith('92')) {
      value = '92' + value.replace(/^92*/, '');
    }
    setPhone(value);
  };

  return (
    <ModalComponent
      size="md"
      show={true}
      handleClose={props.handleCloseVendorloginModal}
    >
      <Modal.Body className="overflow m-2 lgModals customScroll pt-0 mt-0">
        <h1 className="mainHeading mb-4 text-center">Login</h1>
        <p className="subHeading">Log in with your Phone Number.</p>

        <div className="row">
          <div className="col-12 mt-4">
            <label className="formLabel">Enter Phone No.</label>
            <PhoneInput
              country={'pk'}
              value={phone}
              onChange={handlePhoneChange}
              onlyCountries={['pk']}
              disableDropdown={true}
              placeholder='+92 xxx xxxxxxx'
            />
          </div>

          <div className="col-12 mt-4">
            <label className="formLabel">Enter Password</label>
            <input
              type="password"
              placeholder="********"
              className="inputField"
              onChange={(e) => setPassword(e.target.value)}
              value={password}
            />
          </div>

          <div className="col-12 mt-4">
            <Button
              label="Login"
              className="greenBtn w-100"
              onClick={onLogin}
              loading={loginVendorLoading}
            />
          </div>
        </div>
      </Modal.Body>
    </ModalComponent>
  );
};

export default VendorloginModal;